<div class="icon-list">
    <span multilang class="icon-frame" *ngFor="let keyword of keywords">
        <span multilang *ngIf="keyword.name && keyword.code !== 'ado'" [class]="keyword.icon"
            [matTooltip]="keyword.name" matTooltipClass="matTooltip"></span>

        <mat-icon *ngIf="keyword.code==='ado'">wc</mat-icon>
    </span>
</div>